
    import {Component, Vue} from 'vue-property-decorator';
    import confetti from 'canvas-confetti';

    /**
     * Confettis!
     * https://www.kirilv.com/canvas-confetti/
     */
    @Component({})
    export default class Confetti extends Vue {
        confettis() {
            const count = 200;
            const defaults = {
                origin: {y: 0.7}
            };

            function fire(particleRatio: number, opts: any) {
                confetti(Object.assign({}, defaults, opts, {
                    particleCount: Math.floor(count * particleRatio)
                }));
            }

            fire(0.25, {
                spread: 26,
                startVelocity: 55,
            });
            fire(0.2, {
                spread: 60,
            });
            fire(0.35, {
                spread: 100,
                decay: 0.91,
            });
            fire(0.1, {
                spread: 120,
                startVelocity: 25,
                decay: 0.92,
            });
            fire(0.1, {
                spread: 120,
                startVelocity: 45,
            });
        }
    }
